export const defaultTaxPaperState = {
	TypeOfMoney: [],
	TypeOrgAuthority: [],
	TaxPaperFilterCode: [],
	TaxPaperPayerName: [],
	TaxPaperFilterDate: [],
	MTaxStatus: [],
	TaxPaperList: [],
	taxPaperLoaded: false,
	TotalTaxPaperList: 0,
	PayerBankList: [],
	TypeTaxPeriod: [],
	PayTaxPaymentSubmission: {},
	PayTaxPaymentSubmissionDefault: {},
	regisSuccess: false,
	GIPInfo: {},
	bankByTaxPaper: [],
	MustPayTaxAmountReportData: [],
	MustPayTaxAmountReportSummary: {
		TotalCount: 0,
		VNDTotal: 0,
		USDTotal: 0
	},
	MustPayTaxAmountReportDetailData: [],
	MustPayTaxAmountReportDetailTotal: 0
};

export default {
	...defaultTaxPaperState
};
